import { Spinner } from 'reactstrap';

type ButtonVariant =
  | 'primary'
  | 'primaryOutline'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'light'
  | 'default';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
  children?: React.ReactNode;
  varient?: ButtonVariant;
  isLoading?: boolean;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  text = '',
  children,
  // varient = 'primary',
  className = '',
  type = 'submit',
  isLoading = false,
  onClick,
  disabled,
  ...rest
}) => {
  // const varientType: Record<ButtonVariant, string> = {
  //   primary: 'bg-primary-500 text-white hover:bg-primary-400',
  //   primaryOutline:
  //     'bg-primary-100 border border-primary-400 text-white hover:bg-primary-400',
  //   secondary: 'bg-gray-300 text-black hover:bg-gray-200',
  //   success: 'bg-green-400 text-white hover:bg-green-300',
  //   danger: 'bg-red-400 text-white hover:bg-red-300',
  //   light: 'bg-white text-black hover:bg-gray-200',
  //   default: '',
  // };

  return (
    <button
      className={className}
      onClick={onClick}
      type={type}
      disabled={isLoading ? isLoading : disabled}
      {...rest}
    >
      {isLoading ? <Spinner /> : text ? text : children}
    </button>
  );
};

export default Button;
